export const MapSkeleton = () => (
  <div className="h-full bg-gray-100 flex items-center justify-center animate-pulse">
    <div className="text-center">
      <div className="w-16 h-16 mx-auto mb-4 bg-gray-300 rounded-full animate-spin border-4 border-gray-300 border-t-blue-500"></div>
      <p className="text-gray-600">Loading Map...</p>
    </div>
  </div>
);
